import React from 'react';
import Assembly from '../../../components/Modular/Assembly';
import DashboardCard from './DashboardCard';
import type { DashboardMetric } from '../types/Dashboard';

const metrics: DashboardMetric[] = [
  {
    id: 'consultations-today',
    label: 'Consultations Today',
    value: 3,
  },
  {
    id: 'pending-consultations',
    label: 'Pending Consultations',
    value: 5,
  },
  {
    id: 'active-work-sprint',
    label: 'Current Work Sprint',
    value: 'Sprint 08',
  },
  {
    id: 'open-action-items',
    label: 'Open Action Items',
    value: 12,
  },
];

const DashboardSection = () => {
  return (
    <Assembly
      as="div"
      layout="grid"
      gridTemplate="tile-4"
      justifyContent="center"
      alignContent="center"
    >
      {metrics.map((metric) => (
        <DashboardCard
          key={metric.id}
          metric={metric}
          gridArea={`area${metric.id}`}
        />
      ))}
    </Assembly>
  );
};

export default DashboardSection;
